<template>
  <div>
    <div class="card">
      <div class="card-header">
        <b-button variant="primary" size="sm" href="/adm/migracao">Voltar</b-button>
      </div>
      <div class="col-md-12">
        <b-table striped hover :items="dataComputed" :fields="colunas">
          <template #cell(actions)="row">
            <b-button size="sm" @click="show(row.item.id)" variant="primary" title="Ver">
              <i class="fas fa-eye"></i>
            </b-button>
            <b-button size="sm" @click="editar(row.item.id)" variant="success" title="Processar">
              <i class="fas fa-exchange-alt"></i>
            </b-button>
            <b-button size="sm" @click="deletar(row.item.id)" variant="danger" title="Excluir">
              <i class="fas fa-trash"></i>
            </b-button>
          </template>
        </b-table>
        <!-- <v-table
          :column="colunas"
          :data="dataComputed"
          :actions="actionsTable"
          @edit="editar"
          @show="show"
          @delet="deletar"
        ></v-table>-->
      </div>
    </div>

    <!------------------------------------- MODAL DA MIGRACAO DE CLASSE DO DISTRIBUIDOR -------------------------------------------->
    <b-modal title="Migração de Revendedoras" v-model="openModal">
      <b-card>
        <b-card-body>
          <h3 class="text-danger">Atenção.</h3>
          <br />
          <p class="text-info" v-if="revendedora">
            Você está migrando
            <span class="text-primary"> a revendedora {{ revendedora }} </span>
            do distribuidor <strong>{{ origem }} </strong> para o distribuidor
            <strong> {{ destino }}</strong>
          </p>
          <p class="text-info" v-if="!revendedora">
            Você está migrando Todas as revendedoras do distribuidor
            <strong>{{ origem }} </strong> para o distribuidor
            <strong> {{ destino }}</strong>
          </p>
          <h4>Esta função irá processar a migração.</h4>
          <br />
          <h4>Deseja continuar ?</h4>
        </b-card-body>
      </b-card>
      <template #modal-footer>
        <b-button variant="success" size="sm" @click="salvaMigracao" :disabled="loadingSave">
          <b-spinner small variant="secondary" label="Spinning" v-if="loadingSave"></b-spinner>
          <i class="fas fa-exchange-alt" v-else></i> Sim, Migrar
        </b-button>
        <b-button variant="secondary" size="sm" @click="openModal = false" :disabled="loadingSave">
          Fechar
        </b-button>
      </template>
    </b-modal>

    <!------------------------------------- RELATORIO COM AS REVENDEDORAS A SEREM MIGRADAS -------------------------------------------->
    <b-modal v-model="modalVisible" title="Relatório de Migração" size="xl" scrollable>
      <b-card>
        <b-card-body>
          <table class="table table-hover">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Cadastro</th>
                <th>Endereco</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(list, index) in listaRevendedora" :key="index">
                <td>{{ list.revendedora }}</td>
                <td>{{ list.cadastro }}</td>
                <td>{{ list.endereco }}</td>
              </tr>
            </tbody>
          </table>
        </b-card-body>
      </b-card>
      <template #modal-footer>
        <b-button variant="primary" size="sm" @click="modalVisible = false">
          Fechar
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import vSelect from "vue-select";
export default {
  Props: [],
  components: {
    vSelect,
  },
  data() {
    return {
      loadingSave: false,
      datePickerConfig: {
        format: "D/MM/YYYY",
        showClose: true,
      },
      modalVisible: false,
      openModal: false,
      modalRelatorio: false,
      search: "",
      revendedora: "",
      colunas: [
        { key: 'actions', label: "" },
        { key: 'distribuidor_origem', label: 'Origem das Revendedoras' },
        { key: 'distribuidor_destino', label: 'Destino' },
        { key: 'data_migracao', label: 'Data Migração' },
        { key: 'status', label: 'Status' },
        { key: 'usuario', label: 'Solicitante' },
      ],
      data: [],
      origem: "",
      destino: "",
      itensDevolve: [],
      listaDistribuidor: [],
      listaRevendedora: [],
      migracao_id: 0,
      nomedistribuidor: null,
      distribuidor: null,
      status: null,
      errors: [],
    };
  },
  methods: {
    addMigracao() {
      this.modalVisible = false;
    },
    loadDistribuidor() {
      let url = "/adm/distribuidores/combo";
      var vm = this;
      axios
        .get(url)
        .then(function (response) {
          vm.formatSelect(response.data);
        })
        .catch(function (error) {
          console.log(error);
          $(".loading").hide();
        });
    },
    formatSelect(dataLoaded) {
      var data = [];
      dataLoaded.forEach(function (el, index) {
        let obj = {};
        obj.id = el.id;
        obj.codigo = el.codigo + " - " + el.nome;

        data.push(obj);
      });

      this.listaDistribuidor = data;
    },
    loadData() {
      var vm = this;
      axios
        .get("/adm/migracao/listar")
        .then(function (response) {
          vm.formatDataToTable(response.data);
        })
        .catch(function (errors) {
          console.log(errors);
          $(".loading").hide();
        });
    },
    formatDataToTable(dataLoaded) {
      var data = [];
      var qtd = 0;
      dataLoaded.forEach(function (el, index) {
        let obj = {};
        obj.distribuidor_destino = el.destino.nome;
        obj.distribuidor_origem = el.origem.nome;
        obj.data_migracao = new Date(el.created_at).toLocaleString("pt-BR");
        obj.status = el.status;
        obj.usuario = el.usuario_solicitante;
        obj.id = el.id;

        data.push(obj);
      });

      this.data = data;
    },
    editar(id) {
      /*var vm = this;
            vm.openModal = !vm.openmodal;
            this.migracao_id = id;*/

      $(".loading").show();
      this.revendedora = null;
      this.migracao_id = id;
      var vm = this;
      axios
        .get("/adm/migracao/consulta/" + id)
        .then(function (response) {
          let obj = response.data;
          vm.origem = obj.origem;
          vm.destino = obj.destino;
          if (obj.revendedora) {
            vm.revendedora = obj.revendedora;
          }
          vm.openModal = !vm.openModal;
          $(".loading").hide();
        })
        .catch(function (erro) {
          var error = erro.response.data.errors;
          console.log(error);
          vm.$swal("Ops", error, "error");
          $(".loading").hide();
        });
    },
    deletar(id) {
      var vm = this;
      this.$swal({
        title: "Realmente deseja deletar esta solicitação?",
        text: "Esta ação não poderá ser revertida.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, deletar!",
        cancelButtonText: "Não, cancelar!",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          $(".loading").show();
          axios
            .post("/adm/migracao/deleta", {
              id: id,
            })
            .then(function (response) {
              let obj = response.data;
              vm.$swal("Ok", obj.success, "success");
              vm.loadData();
              $(".loading").hide();
            })
            .catch(function (erro) {
              var error = erro.response.data.errors;
              console.log(error);
              vm.$swal("Ops", error, "error");
              $(".loading").hide();
            });
        }
      });
    },
    show(id) {
      var vm = this;
      var obj = [];

      $(".loading").show();
      axios
        .get("/adm/migracao/relatorio/" + id)
        .then(function (response) {
          obj = response.data;
          vm.listaRevendedora = obj;
          vm.modalVisible = true;
          $(".loading").hide();
        })
        .catch(function (errors) {
          console.log(errors);
          $(".loading").hide();
        });
    },

    salvaMigracao() {
      const vm = this;
      let url = "/adm/migracao/processar";
      let data = {
        id: vm.migracao_id,
      };

      vm.loadingSave = true;
      $(".loading").show();

      axios
        .post(url, data)
        .then((response) => {
          vm.loadData();
          vm.openModal = false;
        })
        .catch((error) => {
          var errors = error.response.data.errors;
          if (typeof errors == "object") {
            console.log(errors);
            alert(errors.join("\n"));
          } else {
            alert(errors);
          }
        })
        .finally(() => {
          $(".loading").hide();
          vm.loadingSave = false;
        });
    },
  },
  computed: {
    actionsTable() {
      var actions = ["show", "edit", "delet"];
      return actions;
    },
    ObjListaDistribuidor() {
      var arrayDistribuidor = [];
      this.listaDistribuidor.forEach((item, index) => {
        arrayDistribuidor.push({
          value: item.id,
          label: item.codigo,
        });
      });
      return arrayDistribuidor;
    },
    filteredData() {
      return this.data.filter((item) => {
        return item.id.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
      });
    },
    dataComputed() {
      return this.data;
    },
  },

  mounted() {
    this.loadData();
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// resources/assets/js/components/adm_migracao/Liberacao.vue